import React, { useEffect, useState } from "react";
import axios from "../../api/Config/index";
import { useDispatch, useSelector } from "react-redux";
import { UsersLogin } from "../../api/Actions/SsoB3/SsoB3";
import { BeatLoader } from "react-spinners";
import { DeleteReduxDataLogin } from "../../api/Actions/SsoB3/DeleteReduxDataLogin";
import setAuthorizationHeaders from "../../api/Config/setAuthorizationHeaders";
const InputUser = () => {
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [Remember, setRemember] = useState(false);
  const [ErrorLogin, setErrorLogin] = useState(false);
  const [DisableSubmitLogin, setDisableSubmitLogin] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState(false);
  const LoginData = useSelector((state) => state.UsersLogin.UsersLogin);
  const loginProcess = useSelector((state) => state.ReduxState.loginProcess);
  const domain = localStorage.getItem("domain");

  const dispatch = useDispatch();
  const HandleBackButton = () => {
    dispatch({
      type: "set",
      loginProcess: "domain",
    });
    localStorage.removeItem("domain");
  };

  const handleLogin = () => {
    if (Password.length > 5 && Email.length > 5) {
      setDisableSubmitLogin(true);
      setErrorLogin(false);
      const data = {
        credential: Email,
        password: Password,
        domain: localStorage.getItem("domain"),
        rememberMe: Remember,
      };
      dispatch(UsersLogin(data));
    } else {
      setErrorLogin(true);
      setErrorMessage("Invalid username or password");
    }
  };

  const HandleEnter = (data) => {
    if (data.key === "Enter") {
      handleLogin();
    }
  };

  useEffect(() => {
    console.log(LoginData, "data loginny");
    if (LoginData.success === true) {
      if (LoginData.data.otpId) {
        dispatch({ type: "set", loginProcess: "otp" });
      } else {
        console.log(domain, "INI_DOMAIN");
        if (window.location.origin.includes("localhost")) setAuthorizationHeaders(LoginData.data.sessionToken, domain);
        localStorage.setItem("identityUuid", LoginData.data.identityUuid);
        localStorage.setItem("sessionToken", LoginData.data.sessionToken);
        dispatch({ type: "set", loginProcess: "org" });
      }
    } else {
      if (LoginData.error === "auth.AccessDenied") {
        setErrorLogin(true);
        setErrorMessage("Invalid username or password");
        setDisableSubmitLogin(false);
      } else if (LoginData.error === "auth.OtpAttemptsExceeded") {
        setErrorLogin(true);
        setDisableSubmitLogin(false);
        setErrorMessage("Too many login attempt please wait a minute");
        dispatch(DeleteReduxDataLogin());
      } else if (LoginData.error === "ENOTFOUND" || LoginData.error === "NotFound") {
        setErrorLogin(true);
        setDisableSubmitLogin(false);
        setErrorMessage("Invalid domain please press back button and re-enter domain");
        dispatch(DeleteReduxDataLogin());
      }
    }
  }, [LoginData]);

  useEffect(() => {
    axios.defaults.headers["domain"] = domain || localStorage.getItem("domain");
  }, []);

  // console.log(domain, "FIRST_DOMAIN");
  return (
    <>
      <div className="my-auto h-1/2">
        <div className="flex flex-col w-4/5 sm:w-3/5 mx-auto">
          <label className="ml-4 poppins-800 text-white tracking-lg">Email</label>
          <input onKeyDown={(e) => HandleEnter(e)} onChange={(e) => setEmail(e.target.value)} className="rounded-lg h-12 my-3 px-2" />
          <label className="ml-4 poppins-800 text-white tracking-lg">Password</label>
          <input
            onKeyDown={(e) => HandleEnter(e)}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            className="rounded-lg h-12 my-3 px-2"
          />
          <div className="my-3 mx-4">
            <input onChange={(e) => setRemember(e.target.checked)} type="checkbox" className="mx-2" />
            <label className="text-white poppins-500">Stay logged in</label>
          </div>
          <div className="flex flex-row items-center justify-between">
            <button
              onClick={(e) => handleLogin()}
              disabled={DisableSubmitLogin}
              className="my-3 text-main-blue text-sm mx-auto rad w-28 h-10 bg-white rounded-md poppins-800 text-blue-b3 tracking-widest hover:bg-slate-200"
            >
              {DisableSubmitLogin ? <BeatLoader className="my-auto" color="#075985" size={8} /> : "LOGIN"}
            </button>
          </div>
        </div>
        {ErrorLogin ? <p className="text-red-500 text-center">{ErrorMessage}</p> : ""}
      </div>
    </>
  );
};

export default InputUser;
